import * as React from "react"

import { cn } from "@/lib/utils"

const inputModeByType = {
  email: "email",
  number: "decimal",
  tel: "tel",
  search: "search",
  url: "url",
}

const autoCompleteByType = {
  email: "email",
  tel: "tel",
  url: "url",
  search: "off",
  password: "current-password",
}

const Input = React.forwardRef(({ className, type = "text", inputMode, autoComplete, enterKeyHint, name, ...props }, ref) => {
  const inferredAutoComplete = autoComplete || autoCompleteByType[type] || name || "off"

  return (
    <input
      type={type}
      inputMode={inputMode || inputModeByType[type] || "text"}
      autoComplete={inferredAutoComplete}
      enterKeyHint={enterKeyHint || (type === "search" ? "search" : "next")}
      name={name}
      className={cn(
        "ds-control flex w-full min-w-0 px-3.5 py-2 text-base file:min-h-11 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }